import { Component, inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

import { I18nService } from "@bitwarden/common/abstractions/i18n.service";
import { LogService } from "@bitwarden/common/abstractions/log.service";
import { PlatformUtilsService } from "@bitwarden/common/abstractions/platformUtils.service";
import {
  ConfirmationDialogService,
  CtaNotificationData,
} from "@bitwarden/web-vault/app/services/confirmation/confirmation.service";
import { FiskilConsentService } from "@bitwarden/web-vault/app/services/syncing/fiskil/fiskil-consent.service";

@Component({
  selector: "app-remove-fiskil-consent",
  templateUrl: "./remove-fiskil-consent.component.html",
})
export class RemoveFiskilConsentComponent {
  private fiskilConsentService = inject(FiskilConsentService);
  private confirmationDialog = inject(ConfirmationDialogService);
  private i18nService = inject(I18nService);
  private platformUtilsService = inject(PlatformUtilsService);
  private logService = inject(LogService);
  private dialogRef = inject(MatDialogRef<RemoveFiskilConsentComponent>);

  deleting = false;

  async submit() {
    const data: CtaNotificationData = {
      title: this.i18nService.t("fiskilRevokeConsentConfirmTitle"),
      message: this.i18nService.t("fiskilPluginUninstallMessage"),
      cancel: { method: () => {}, title: this.i18nService.t("cancel") },
      confirm: {
        method: () => this.executeRemove(),
        title: this.i18nService.t("fiskilRevokeConsentConfirmButton"),
      },
      reminder: null,
    };
    await this.confirmationDialog.ctaNotification(data);
  }

  private async executeRemove() {
    this.dialogRef.close();

    try {
      this.deleting = true;
      await this.fiskilConsentService.removeConsentAndData();
    } catch (e) {
      this.platformUtilsService.showToast(
        "error",
        "Error Occurred",
        this.i18nService.t("somethingWentWrong"),
      );
      this.logService.error(e);
    } finally {
      this.deleting = false;
    }
  }

  closeForm() {
    this.dialogRef.close();
  }
}
